"use strict";
console.log('\n'
    + '  /$$$$$$  /$$   /$$  /$$$$$$   /$$$$$$                               \n'
    + ' /$$__  $$| $$  | $$ /$$__  $$ /$$__  $$                              \n'
    + '| $$  \\__/| $$  | $$| $$  \\ $$| $$  \\ $$                              \n'
    + '| $$      | $$$$$$$$| $$  | $$| $$  | $$                              \n'
    + '| $$      | $$__  $$| $$  | $$| $$  | $$                              \n'
    + '| $$    $$| $$  | $$| $$  | $$| $$  | $$                              \n'
    + '|  $$$$$$/| $$  | $$|  $$$$$$/|  $$$$$$/                              \n'
    + ' \\______/ |__/  |__/ \\______/  \\______/                               \n'
    + '  /$$$$$$  /$$   /$$  /$$$$$$   /$$$$$$                               \n'
    + ' /$$__  $$| $$  | $$ /$$__  $$ /$$__  $$                              \n'
    + '| $$  \\__/| $$  | $$| $$  \\ $$| $$  \\ $$                              \n'
    + '| $$      | $$$$$$$$| $$  | $$| $$  | $$                              \n'
    + '| $$      | $$__  $$| $$  | $$| $$  | $$                              \n'
    + '| $$    $$| $$  | $$| $$  | $$| $$  | $$                              \n'
    + '|  $$$$$$/| $$  | $$|  $$$$$$/|  $$$$$$/                              \n'
    + ' \\______/ |__/  |__/ \\______/  \\______/                               \n'
    + ' /$$      /$$  /$$$$$$  /$$$$$$$$/$$   /$$ /$$$$$$$$ /$$$$$$$         \n'
    + '| $$$    /$$$ /$$__  $$|__  $$__/ $$  | $$| $$_____/| $$__  $$        \n'
    + '| $$$$  /$$$$| $$  \\ $$   | $$  | $$  | $$| $$      | $$  \\ $$        \n'
    + '| $$ $$/$$ $$| $$  | $$   | $$  | $$$$$$$$| $$$$$   | $$$$$$$/ /$$$$$$\n'
    + '| $$  $$$| $$| $$  | $$   | $$  | $$__  $$| $$__/   | $$__  $$|______/\n'
    + '| $$\\  $ | $$| $$  | $$   | $$  | $$  | $$| $$      | $$  \\ $$        \n'
    + '| $$ \\/  | $$|  $$$$$$/   | $$  | $$  | $$| $$$$$$$$| $$  | $$        \n'
    + '|__/     |__/ \\______/    |__/  |__/  |__/|________/|__/  |__/        \n'
    + ' /$$$$$$$$/$$   /$$  /$$$$$$  /$$   /$$ /$$$$$$$$ /$$$$$$$            \n'
    + '| $$_____/ $$  | $$ /$$__  $$| $$  /$$/| $$_____/| $$__  $$           \n'
    + '| $$     | $$  | $$| $$  \\__/| $$ /$$/ | $$      | $$  \\ $$           \n'
    + '| $$$$$  | $$  | $$| $$      | $$$$$/  | $$$$$   | $$$$$$$/           \n'
    + '| $$__/  | $$  | $$| $$      | $$  $$  | $$__/   | $$__  $$           \n'
    + '| $$     | $$  | $$| $$    $$| $$\\  $$ | $$      | $$  \\ $$           \n'
    + '| $$     |  $$$$$$/|  $$$$$$/| $$ \\  $$| $$$$$$$$| $$  | $$           \n'
    + '|__/      \\______/  \\______/ |__/  \\__/|________/|__/  |__/           \n'
    + '                                                                      \n'
    + '    oooOOO#FF0000OOO"\n'
    + '   o   ____          :::::::::::::::::: :::::::::::::::::: __|-----|__\n'
    + '   Y_,_|[]| --++++++ |[][][][][][][][]| |[][][][][][][][]| |  [] []  |\n'
    + '  {|_|_|__|;|______|;|________________|;|________________|;|_________|;\n'
    + '   /oo--OO   oo  oo   oo oo      oo oo   oo oo      oo oo   oo     oo\n'
    + '+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+-+');
